{
    "ErrorMessage": "Nous n'avons pas pu charger le fichier audio.",
    "NAME": "MediaPlayer"
}